'use client';

import React from 'react';
import ErrorStateScreen from '@/components/ErrorStateScreen';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return <ErrorStateScreen data-component-id="src/app/error.tsx:13:9" data-component-path="src/app/error.tsx" data-component-line="13" data-component-end-line="13" data-component-file="error.tsx" data-component-name="ErrorStateScreen" data-component-content="%7B%22elementName%22%3A%22ErrorStateScreen%22%7D" error={error} reset={reset} />;
}
